import "prismjs";
import "prismjs/components/prism-icu-message-format";
